import './LoadingScreen.css';

/* ─────────────────────────────────────────────────────────────
   LOADING SCREEN — displayed while AuthContext checks whether
   a user session exists on first load. The three stars pulse
   one by one to signal the app is working.

   We read the theme directly from localStorage here because
   the CSS variables (--bg, --accent) aren't applied until
   App.js runs its useEffect — which happens after this first
   render. Reading from localStorage avoids the color flash.
   ───────────────────────────────────────────────────────────── */
function LoadingScreen() {
  const theme = localStorage.getItem('ranktt-theme') || 'dark';
  const bg = theme === 'dark'     ? '#0e0e10'
           : theme === 'midnight' ? '#080b14'
           : theme === 'flower'   ? '#fdf0dc'
           :                        '#faf7f0';
  const accent = theme === 'dark'     ? '#D4601C'
               : theme === 'midnight' ? '#22d3ee'
               : theme === 'flower'   ? '#c054a0'
               :                        '#E86C1F';

  return (
    <div className="loading-screen" style={{ background: bg }}>
      <div className="loading-stars">
        <span className="loading-star" style={{ color: accent }}>★</span>
        <span className="loading-star" style={{ color: accent }}>★</span>
        <span className="loading-star" style={{ color: accent }}>★</span>
      </div>
    </div>
  );
}

export default LoadingScreen;
